export default __webpack_public_path__ + "static/pikachu-f8db396b1370a1b85f77ac664ba2f8c9.png";